import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { getProductDetailsLink } from 'apps/products/links';
import FopTrackLink from '../../analytics/components/FopTrackLink';

import MultilineTrim from 'widgets/MultilineTrim/MultilineTrim';
import ImageWithCorner from './ImageWithCorner';
import PackInfo from './PackInfo';

class FopContentBasic extends Component {
  static propTypes = {
    betaFeatures: PropTypes.array.isRequired,
    children: PropTypes.node,
    location: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    product: PropTypes.shape({
      name: PropTypes.string.isRequired,
      catchWeight: PropTypes.string,
      packInfo: PropTypes.object,
    }).isRequired,
    productGtmData: PropTypes.object.isRequired,
    router: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  shouldComponentUpdate(nextProps) {
    return (
      this.props.product !== nextProps.product
      || this.props.children !== nextProps.children
    );
  }

  get bopUrl() {
    const { betaFeatures, location, params, product } = this.props;

    return getProductDetailsLink({ product, location, params, betaFeatures });
  }

  getGtmData = () => {
    const { productGtmData } = this.props;
    this.productGtmData = this.productGtmData || {
      gtmEvent: 'gtm:productClick',
      gtmData: productGtmData,
      gtmDataUrl: this.bopUrl,
    };
    return this.productGtmData;
  };

  render() {
    const { bopUrl } = this;
    const {
      children,
      product,
      router,
      betaFeatures = [],
    } = this.props;

    return (
      <div className="fop-contentWrapper">
        <FopTrackLink
          {...this.getGtmData()}
          to={bopUrl}
          routerPush={router.push}
        >
          <div className="fop-content">
            <div className="fop-img-wrapper">
              <ImageWithCorner product={product} />
              <PackInfo product={product} showFPBadge={betaFeatures.includes('FOODMAESTRO_ENABLED')} />
            </div>
            <div className="fop-description">
              <h4 className="fop-title" title={product.name}>
                <MultilineTrim maxLines={2}>
                  {product.name}
                </MultilineTrim>
                {product.catchWeight && <span className="fop-catch-weight-inline">{product.catchWeight}</span>}
              </h4>
              <span className="fop-catch-weight">{product.catchWeight}</span>
            </div>
          </div>
        </FopTrackLink>
        {children}
      </div>
    );
  }
}

export default withRouter(FopContentBasic);
